import Box from '@mui/material/Box';
import { memo } from 'react';

import { petrol, yellow } from '../../../styles/mui/colors';
import IconMap from '../../Icons/IconMap';

/**
 * SearchIconAction component renders the custom styled search icon for the BottomNavigationBar.
 *
 * @param {object} props - The component props.
 * @param {boolean} props.isActive - Indicates if the search icon is active.
 * @returns {JSX.Element} - The rendered component.
 */
const SearchIconAction = memo(({ isActive }) => {
  const outerCircleStyles = {
    borderRadius: '50%',
    p: '12px 12px 0 12px',
    backgroundColor: 'white',
  };

  const innerCircleStyles = {
    borderRadius: '50%',
    p: 1.2,
    backgroundColor: isActive ? yellow.main : petrol.main,
    boxShadow: isActive ? `0px 3px 12px 0 ${yellow.main}` : 'none',
    transition: 'background-color 0.3s, box-shadow 0.3s',
  };

  return (
    <Box sx={outerCircleStyles}>
      <Box sx={innerCircleStyles}>
        <IconMap color={isActive ? petrol.main : 'white'} fontSize="large" />
      </Box>
    </Box>
  );
});

export default SearchIconAction;
